import Link from 'next/link'

interface ISectionHeaderProps {
  title: string
  subtitle?: string
  link?: { href: string; label: string }
}

export default function SectionHeader({ title, subtitle, link }: ISectionHeaderProps) {
  return (
    <div className="flex items-baseline gap-3">
      <h2 className="text-xl font-semibold tracking-tight">{title}</h2>
      <span className="flex-1 text-sm text-trust-center-muted">{subtitle}</span>
      {link && (
        <Link href={link.href} className="text-sm font-medium text-trust-center-accent hover:text-trust-center">
          {link.label}
        </Link>
      )}
    </div>
  )
}
